import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
var propTypes = {
  /**
  * Layout of the StandardBanner
  * Available options: "half-and-half", "full-width-image", "two-images", "side-by-side"
  */
  layout: PropTypes.oneOf(['half-and-half', 'full-width-image', 'two-images', 'side-by-side']),

  /**
  * How text should be aligned horizontally within the StandardBanner
  * Available options: "left", "center", "right"
  */
  textHorizontalAlign: PropTypes.oneOf(['left', 'center', 'right']),

  /**
  * How text should be aligned vertically within the StandardBanner
  * Available options: "center", "top", "bottom"
  * Note: the default value for this prop changes based on the layout prop.
  * if layout = 'side-by-side' the default value is 'bottom' otherwise it's 'center'
  */
  textVerticalAlign: PropTypes.oneOf(['center', 'top', 'bottom'])
};
var StandardBanner = createComponent({
  displayName: 'StandardBanner',
  root: 'div',
  propTypes: propTypes,
  requiredStyleKeys: SWAN_STYLE_KEY_MAP.standardBanner,
  propConfig: {
    classNames: function classNames(props) {
      var layout = props.layout,
          _props$textVerticalAl = props.textVerticalAlign,
          textVerticalAlign = _props$textVerticalAl === void 0 ? layout === 'side-by-side' ? 'bottom' : 'center' : _props$textVerticalAl,
          textHorizontalAlign = props.textHorizontalAlign;
      var classNameSet = new Set(['swan-standard-banner']);
      if (layout && layout !== 'half-and-half') classNameSet.add("swan-standard-banner-layout-".concat(layout));
      if (textVerticalAlign) classNameSet.add("swan-standard-banner-text-vertical-align-".concat(textVerticalAlign));
      if (textHorizontalAlign) classNameSet.add("swan-standard-banner-text-align-".concat(textHorizontalAlign));
      return classNameSet;
    }
  }
});
StandardBanner.defaultProps = {
  layout: 'half-and-half',
  textHorizontalAlign: 'left'
};
export { StandardBanner };